export default __webpack_public_path__ + "static/media/questionMark.2f0567a4.svg";